import { useParams } from 'react-router-dom';

import GroupForm from '@/components/groups/GroupForm';

export default function EditGroupPage() {
  const { id } = useParams<{ id: string }>();
  // Key forces remount when switching between groups, ensuring clean state
  return <GroupForm key={id} groupId={id} mode="edit" />;
}
